import { graphApiClient } from "./apiClients";
import type { Presence } from "models/ContactsMetiers";

function getUserEndpoint(userId?: string): string {
  return userId != null ? `users/${userId}` : "me";
}

/**
 * Récupère les informations de présence d'un utilisateur précis, ou de l'utilisateur actuellement authentifié
 * @param userId `string` optionnel - l'id de l'utilisateur
 * @returns `Presence` contenant les informations de présence
 */
async function getUserPresence(userId?: string): Promise<Presence> {
  const url = `https://graph.microsoft.com/beta/${getUserEndpoint(userId)}/presence`;
  return graphApiClient.get<Presence, Presence>(url);
}

export const graphService = {
  getUserPresence,
};
